(function () {
  'use strict';

  function setDisclosureState(container, trigger, isOpen) {
    if (!container || !trigger) {
      return;
    }

    container.classList.toggle('hide', !isOpen);
    container.setAttribute(
      'aria-hidden',
      isOpen ? 'false' : 'true'
    );

    trigger.classList.toggle('_open', isOpen);
    trigger.setAttribute(
      'aria-expanded',
      isOpen ? 'true' : 'false'
    );
  }

  function addMediaChangeListener(mediaQuery, callback) {
    if (!mediaQuery || !callback) {
      return;
    }

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', callback);
      return;
    }

    if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(callback);
    }
  }

  function initBedzHeaderButtons() {
    var searchTrigger = document.querySelector('.search-btn');
    var searchContainer =
      document.getElementById('search-container');

    var menuTrigger = document.querySelector('.menu-btn');
    var menuContainer =
      document.getElementById('menu-container');

    var searchMedia =
      window.matchMedia('(max-width: 749px)');

    var menuMedia =
      window.matchMedia('(max-width: 767px)');

    /* Always begin from a known closed state — This prevents stale preview / resize state from surviving */
    if (searchTrigger && searchContainer) {
      setDisclosureState(
        searchContainer,
        searchTrigger,
        false
      );
    }

    if (menuTrigger && menuContainer) {
      setDisclosureState(
        menuContainer,
        menuTrigger,
        false
      );
    }

        if (searchTrigger && searchContainer) {
      searchTrigger.addEventListener(
        'click',
        function (event) {
          if (!searchMedia.matches) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          /* Search 2.0 already owns a search field on the — native Shopify search-results page */

          var pageSearchInput =
            document.querySelector(
              'body.template-search .bedz-search-form__input'
            );

          if (pageSearchInput) {
            setDisclosureState(
              searchContainer,
              searchTrigger,
              false
            );

            window.requestAnimationFrame(function () {
              pageSearchInput.focus();
            });

            return;
          }

          /* All other mobile storefront routes continue using — the normal expandable header search */

          var searchInput =
            searchContainer.querySelector(
              'input[type="search"]'
            );

          var isOpening =
            searchContainer.classList.contains('hide');

          setDisclosureState(
            searchContainer,
            searchTrigger,
            isOpening
          );

          if (isOpening && searchInput) {
            window.requestAnimationFrame(function () {
              searchInput.focus();
            });
          } else {
            if (
              searchInput &&
              document.activeElement === searchInput
            ) {
              searchInput.blur();
            }

            searchTrigger.focus();
          }
        }
      );
    }

    if (menuTrigger && menuContainer) {
      menuTrigger.addEventListener(
        'click',
        function (event) {
          if (!menuMedia.matches) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          var isOpening =
            menuContainer.classList.contains('hide');

          setDisclosureState(
            menuContainer,
            menuTrigger,
            isOpening
          );

          if (!isOpening) {
            menuTrigger.focus();
          }
        }
      );
    }

    /* Crossing either responsive boundary must close its — disclosure and restore the markup / ARIA state */
    addMediaChangeListener(
      searchMedia,
      function () {
        if (searchContainer && searchTrigger) {
          setDisclosureState(
            searchContainer,
            searchTrigger,
            false
          );
        }
      }
    );

    addMediaChangeListener(
      menuMedia,
      function () {
        if (menuContainer && menuTrigger) {
          setDisclosureState(
            menuContainer,
            menuTrigger,
            false
          );
        }
      }
    );

    document.addEventListener(
      'click',
      function (event) {
        if (
          searchMedia.matches &&
          searchContainer &&
          searchTrigger &&
          !searchContainer.classList.contains('hide') &&
          !searchContainer.contains(event.target) &&
          !searchTrigger.contains(event.target)
        ) {
          setDisclosureState(
            searchContainer,
            searchTrigger,
            false
          );
        }

        if (
          menuMedia.matches &&
          menuContainer &&
          menuTrigger &&
          !menuContainer.classList.contains('hide') &&
          !menuContainer.contains(event.target) &&
          !menuTrigger.contains(event.target)
        ) {
          setDisclosureState(
            menuContainer,
            menuTrigger,
            false
          );
        }
      }
    );
  }

  function initBedzPreviousPage() {
    var links = document.querySelectorAll(
      '[data-bedz-previous-page]'
    );
    var storageKey = 'bedzPreviousStorefrontUrl';

    function isExcludedPath(pathname) {
      return (
        pathname === '/cart' ||
        pathname === '/checkout' ||
        pathname.indexOf('/checkouts/') === 0
      );
    }

    function getStoredUrl() {
      try {
        return window.sessionStorage.getItem(storageKey) || '';
      } catch (error) {
        return '';
      }
    }

    function rememberCurrentUrl() {
      if (isExcludedPath(window.location.pathname)) {
        return;
      }

      try {
        window.sessionStorage.setItem(
          storageKey,
          window.location.pathname +
            window.location.search +
            window.location.hash
        );
      } catch (error) {
        return;
      }
    }

    rememberCurrentUrl();

    if (!links.length) {
      return;
    }

    for (var i = 0; i < links.length; i += 1) {
      links[i].addEventListener(
        'click',
        function (event) {
          var referrer = document.referrer;
          var storedUrl = getStoredUrl();

          if (!referrer) {
            if (storedUrl) {
              event.preventDefault();
              window.location.assign(storedUrl);
            }
            return;
          }

          try {
            var previousUrl = new URL(referrer);
            var previousIsStorefront =
              previousUrl.origin === window.location.origin &&
              !isExcludedPath(previousUrl.pathname);

            if (
              previousIsStorefront &&
              window.history &&
              window.history.length > 1
            ) {
              event.preventDefault();
              window.history.back();
              return;
            }

            if (storedUrl) {
              event.preventDefault();
              window.location.assign(storedUrl);
            }
          } catch (error) {
            if (storedUrl) {
              event.preventDefault();
              window.location.assign(storedUrl);
            }
          }
        }
      );
    }
  }

  function initBedzHeader() {
    initBedzHeaderButtons();
    initBedzPreviousPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initBedzHeader
    );
  } else {
    initBedzHeader();
  }
})();
